import React from "react"
import Card from "../atoms/card"
import styled from "styled-components"
import media from "styled-media-query"

const CardWrap = styled(Card)<{ isAnswer?: boolean }>`
  @media screen and (min-width: 450px) {
    &:hover {
      background-color: ${props => (props.isAnswer ? "" : "#f1f6fd")};
      color: ${props => (props.isAnswer ? "" : "#0145a2")};
      transition: ${props => (props.isAnswer ? "" : ".5s")};
    }
  }
`
const LeftWrap = styled.p`
  align-items: center;
  background-color: #f1f6fd;
  border-radius: 100px 0 0 100px;
  color: #0445a3;
  display: flex;
  font-size: 0.833em;
  height: 100%;
  justify-content: center;
  margin: auto;
  width: 16%;
  ${media.greaterThan("small")`
    font-size: 12px;
    padding-left: 4px;
  `}
`
const RightWrap = styled.p<{ isAnswer?: boolean }>`
  align-items: center;
  display: flex;
  flex: 1;
  font-size: ${props => (props.isAnswer ? "10px" : "3.2vw")};
  font-weight: ${props => (props.isAnswer ? "400" : "")};
  justify-content: center;
  letter-spacing: 0.5px;
  text-align: center;

  margin: ${props => (props.isAnswer ? "0 -6vw 0 0" : "")};
  padding: ${props => (props.isAnswer ? "0" : ".5em 8vw .5em 0")};
  transform: ${props => (props.isAnswer ? "scale(0.85)" : "")};
  transform-origin: ${props => (props.isAnswer ? "0" : "")};

  ${media.greaterThan("small")`
    font-size: 13px;
    padding: 0 2vw 0 1vw;
    transform: none;
    margin: auto;
  `}
`

const Choice = props => {
  const element = props.element
  const index: number = element.index
  const text: string = element.text
  const isAnswer: boolean = props.isAnswer
  return (
    <CardWrap isAnswer={isAnswer}>
      <LeftWrap>{index}</LeftWrap>
      <RightWrap isAnswer={isAnswer}>{text}</RightWrap>
    </CardWrap>
  )
}

export default Choice
